import { useAppSelector } from '../../../../hooks/redux'
import { RoutesPath } from '../../../../constants/RoutesPath'
import { Strings } from '../../../../constants/Strings'
import NavBarItem from "./NavBarItem/NavBarItem"

const NavBar = () => {
    
    const language = useAppSelector<string>(state => state.language.language)

    return (
        <nav>
            <NavBarItem
                to={RoutesPath.privacyPolicy}
                icon={"fas fa-shield-halved"}
                title={Strings[language ?? 'tm'].privacyPolicy}
                count={null}
            />
            <NavBarItem
                to={RoutesPath.privacyPolicyProfile + '/remove-data'}
                icon={"fas fa-user"}
                title={Strings[language ?? 'tm'].profileData}
                count={null}
            />
        </nav>
    )
}

export default NavBar
